import AccountList from './AccountList.vue'

export default AccountList